import monochrome from '@dist/svg/sprites/monochrome.sprite.json';
import multicolor from '@dist/svg/sprites/multicolor.sprite.json';
import websprite from '@dist/svg/sprites/web.sprite.json';

/**
 * Glyph sizes
 *
 * @return {string[]}
 */

const addPrefix = (sprite, prefix) => sprite.symbols.map((i) => prefix + i);

export const GLYPHS = [...addPrefix(monochrome, ''), ...addPrefix(multicolor, ''), ...websprite.symbols];

// `xs` size was not here which was throwing annoying validation errors.
// Meanwhile, glyph.vue styles contain description for `xs` and even `xxs`.
// TODO: to discuss possible sizes with the design team.
export const SIZES = ['xxs', 'xs', 's', 'm', 'l', 'xxxl'];

export const COLORS = [
    'blue',
    'orange',
    'azure',
    'white',
    'brand-light',
    'brand-primary',
    'brand-secondary',
    'fixed-success',
    'nav-primary',
    'nav-secondary',
    'orange-bright',
    'lime',
];
